import { cn } from "@/utils/cn";
import { forwardRef, useId, type InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  ariaDescription?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ariaDescription, ...props }, ref) => {
    const generatedId = useId();
    const descriptionId = ariaDescription ? `${generatedId}-desc` : undefined;

    return (
      <>
        <input
          ref={ref}
          aria-invalid={error || undefined}
          aria-describedby={descriptionId ?? props["aria-describedby"]}
          className={cn(
            "flex h-8 w-full rounded-[3px] border bg-white px-3 py-1 text-base placeholder:text-zinc-400 focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-50",
            error
              ? "border-red-700 focus:ring-red-700"
              : "border-zinc-300 focus:ring-zinc-900",
            className,
          )}
          {...props}
        />
        {ariaDescription && (
          <span id={descriptionId} className="sr-only">
            {ariaDescription}
          </span>
        )}
      </>
    );
  },
);
Input.displayName = "Input";
